export default __webpack_public_path__ + "static/media/apiaryweb.9a82affd.png";